import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
    return (
        <footer>
            <div className='page_wrapper'>
                <div className='main_footer'>
                    <div className='footer_info'>
                        <div className='footer_newsletter'>
                            <h2>
                                Subscribe to our newsletter to stay in touch with the latest.
                            </h2>
                            <p>We know winning isn’t everything. However, among the many awards we’ve received, we highlight the most prestigious and respected among international design communities.</p>
                        </div>
                        <div className='footer_social_media'>
                            <Link to="/">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g weight="fill"><path d="M215,219.85a8,8,0,0,1-7,4.15H160a8,8,0,0,1-6.75-3.71l-40.49-63.63L53.92,221.38a8,8,0,0,1-11.84-10.76l61.77-68L41.25,44.3A8,8,0,0,1,48,32H96a8,8,0,0,1,6.75,3.71l40.49,63.63,58.84-64.72a8,8,0,0,1,11.84,10.76l-61.77,67.95,62.6,98.38A8,8,0,0,1,215,219.85Z" fill="white"></path></g></svg>
                            </Link>
                            <Link to="/">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g weight="fill"><path d="M176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24ZM128,176a48,48,0,1,1,48-48A48.05,48.05,0,0,1,128,176Zm60-96a12,12,0,1,1,12-12A12,12,0,0,1,188,80Zm-28,48a32,32,0,1,1-32-32A32,32,0,0,1,160,128Z" fill="white"></path></g></svg>
                            </Link>
                        </div>
                    </div>

                    <div className='footer_links'>
                        {/* <ul>
                            <li><a href='#'>About</a></li>
                            <li><a href='#'>Service</a></li>
                            <li><a href='#'>Portfolio</a></li>
                            <li><a href='#'>Contact</a></li>
                        </ul> */}
                    </div>

                    <div className='footer_contact'>
                        <h3>Inquiries</h3>
                        <p><a href="mailto:info@gmail.com">akashsen127@gmail.com</a></p>
                        <p><a href='tel:+8770562180'>+87 705 62180</a></p>
                    </div>

                </div>
            </div>
            <div className="footer_copyright">
                <div className='page_wrapper'>
                    <p>&copy; 2023 My Portfolio. All rights reserved.</p>
                </div>
            </div>

        </footer>
    );
};

export default Footer;